import { Routes } from '@angular/router';

import { LoginComponent } from './auth/login/login.component';
import { unifiedAuthGuard, adminAuthGuard } from './core/auth/auth-guard';
import { permissionGuard } from './core/auth/permission-guard';
import { moduleEnabledGuard } from './core/commerce/module-enabled.guard';
import { P_COMMERCE } from './core/constants/permissions';
import { CanDeactivateGuard } from './core/auth/can-deactivate.guard';
import { PageIndexComponent } from './feature/center-business/order/internal/page-index/page-index';
import { OrderCreateComponent } from './feature/center-business/order/internal/order-create/order-create.component';
import { StandardOrderViewComponent } from './feature/center-business/order/internal/view/standard-order-view.component';
import { TagManagement } from './feature/tag-management/tag-management';
import { OrderAuditComponent } from './feature/center-business/order/audit/order-audit.component';
import { OrderPreemptComponent } from './feature/center-business/order/preempt/order-preempt.component';
import { OrderSourceComponent } from './feature/center-business/order/source/order-source.component';
import { OrderShortComponent } from './feature/center-business/order/short/order-short.component';
import { O2OInternalComponent } from './feature/center-business/o2o/internal/o2o-internal.component';
import { O2OCreateComponent } from './feature/center-business/o2o/o2o-create/o2o-create.component';
import { O2OAuditComponent } from './feature/center-business/o2o/audit/o2o-audit.component';
import { O2oStuckAlertComponent } from './feature/center-business/o2o/stuck-alert/o2o-stuck-alert.component';
import { O2OOrderViewComponent } from './feature/center-business/o2o/view/o2o-order-view.component';
import { O2OChangeHistoryComponent } from './feature/center-business/o2o/change-history/o2o-change-history.component';
import { ThirdPartyO2OComponent } from './feature/center-business/third-party/third-party-o2o/third-party-o2o.component';
import { ThirdPartyAfterComponent } from './feature/center-business/third-party/third-party-after/third-party-after.component';
import { ThirdPartyOrderComponent } from './feature/center-business/third-party/third-party-order/third-party-order.component';
import { MarketplaceOrderComponent } from './feature/center-business/third-party/marketplace-order/marketplace-order.component';
import { MarketplaceOrderViewComponent } from './feature/center-business/third-party/marketplace-order/view/marketplace-order-view.component';
import { ThirdPartyGoodsComponent } from './feature/center-business/third-party/third-party-goods/third-party-goods.component';
import { InternalAfterComponent } from './feature/center-business/after/internal/after/internal-after.component';
import { InternalReturnComponent } from './feature/center-business/after/internal/return/internal-return.component';
import { InternalReturnViewComponent } from './feature/center-business/after/internal/return/view/internal-return-view.component';
import { AfterAuditComponent } from './feature/center-business/after/audit/after/after-audit.component';
import { ReturnAuditComponent } from './feature/center-business/after/audit/return/return-audit.component';
import { ProductReviewComponent } from './feature/product-review/components/product-review';
import { ProductDetailComponent } from './feature/product-review/components/product-detail';
import { ProductAuditComponent } from './feature/product-review/components/product-audit';
import { SKUManagementComponent } from './feature/center-business/goods/sku/components/sku-management/sku-management.component';
import { SKUDetailComponent } from './feature/center-business/goods/sku/components/sku-detail/sku-detail.component';
import { SKUEditComponent } from './feature/center-business/goods/sku/components/sku-edit/sku-edit.component';
import { SKUCreateComponent } from './feature/center-business/goods/sku/components/sku-create/sku-create.component';
import { SpuManagerComponent } from './feature/center-business/goods/spu/spu-manager/spu-manager.component';
import { OrdinarySpuComponent } from './feature/center-business/goods/spu/ordinary/ordinary-spu.component';
import { PackageSpuComponent } from './feature/center-business/goods/spu/package/package-spu.component';
import { OrdinarySpuAddComponent } from './feature/center-business/goods/spu/ordinary/ordinary-spu-add/ordinary-spu-add.component';
import { OrdinarySpuEditComponent } from './feature/center-business/goods/spu/ordinary/ordinary-spu-edit/ordinary-spu-edit.component';
import { OrdinarySpuViewComponent } from './feature/center-business/goods/spu/ordinary/ordinary-spu-view/ordinary-spu-view.component';
import { PackageSpuAddComponent } from './feature/center-business/goods/spu/package/package-spu-add/package-spu-add.component';
import { PackageSpuEditComponent } from './feature/center-business/goods/spu/package/package-spu-edit/package-spu-edit.component';
import { PackageSpuViewComponent } from './feature/center-business/goods/spu/package/package-spu-view/package-spu-view.component';
import { MaterialComponent } from './feature/center-business/goods/material/material.component';
import { MaterialListComponent } from './feature/center-business/goods/material/material-list/material-list.component';
import { MaterialFormComponent } from './feature/center-business/goods/material/material-form/material-form.component';
import { SyncReportComponent } from './feature/center-business/goods/sync-report/sync-report.component';
import { BrandComponent } from './feature/center-business/goods/brand/brand.component';
import { BrandAddComponent } from './feature/center-business/goods/brand/brand-add/brand-add.component';
import { BrandEditComponent } from './feature/center-business/goods/brand/brand-edit/brand-edit.component';
import { StockSearchComponent } from './feature/center-business/stock/search/stock-search.component';
import { BarcodeCorrectionsComponent } from './feature/center-business/stock/barcode-corrections/barcode-corrections.component';
import { PriceListComponent } from './feature/center-business/goods/price-list/price-list.component';
import { SellingPricePolicyComponent } from './feature/configuration/price/selling-price-policy.component';
import { FlashSaleQuotaPolicyComponent } from './feature/configuration/price/flash-sale-quota-policy.component';
import { PriceHistoryComponent } from './feature/center-business/goods/price-list/price-history.component';
import { ProductPricingEditComponent } from './feature/center-business/goods/product-pricing/edit/product-pricing-edit.component';
import { ProductPricingAddComponent } from './feature/center-business/goods/product-pricing/add/product-pricing-add.component';
import { StockChangeComponent } from './feature/center-business/stock/change/stock-change.component';
import { PackageOperationComponent } from './feature/center-business/stock/package-operation/package-operation.component';
import { StockViewComponent } from './feature/center-business/stock/transfer/virtual/view/stock-view.component';
import { ChangeApprovalComponent } from './feature/center-business/stock/change-approval/change-approval.component';
import { InboundComponent } from './feature/center-business/stock/inbound/inbound.component';
import { TransferComponent } from './feature/center-business/stock/transfer/virtual/transfer.component';
import { TransferViewComponent } from './feature/center-business/stock/transfer/virtual/transfer-view.component';
import { TransferAddComponent } from './feature/center-business/stock/transfer/virtual/transfer-add/transfer-add.component';
import { LogicTransferComponent } from './feature/center-business/stock/transfer/logic/logic-transfer.component';
import { LogicTransferViewComponent } from './feature/center-business/stock/transfer/logic/logic-transfer-view.component';
import { LogicTransferAddComponent } from './feature/center-business/stock/transfer/logic/logic-transfer-add/logic-transfer-add.component';
import { LogicTransferEditComponent } from './feature/center-business/stock/transfer/logic/logic-transfer-edit/logic-transfer-edit.component';
import { SaleReportComponent } from './feature/center-business/report/sale-report/sale-report.component';

import { InboundWarrantViewComponent } from './feature/center-business/stock/inbound/inbound-warrant-view/inbound-warrant-view.component';
import { InboundNoticeViewComponent } from './feature/center-business/stock/inbound/inbound-notice/inbound-notice-view/inbound-notice-view.component';
import { InboundNoticeEditComponent } from './feature/center-business/stock/inbound/inbound-notice/inbound-notice-edit/inbound-notice-edit.component';
import { InboundAddComponent } from './feature/center-business/stock/inbound/inbound-add/inbound-add.component';
import { InboundEditComponent } from './feature/center-business/stock/inbound/inbound-edit/inbound-edit.component';
import { ReceiveGoodsComponent } from './feature/center-business/stock/inbound/inbound-edit/components/receive-goods/receive-goods.component';
import { PickGoodsComponent } from './feature/center-business/stock/delivery/delivery-order/components/pick-goods/pick-goods.component';
import { ConfirmShippingComponent } from './feature/center-business/stock/delivery/delivery-order/components/confirm-shipping/confirm-shipping.component';
import { InboundResultViewComponent } from './feature/center-business/stock/inbound/inbound-result-view/inbound-result-view.component';
import { StockDeliveryManagerComponent } from './feature/center-business/stock/delivery/stock-delivery-manager.component';
import { StockDeliveryOrderComponent } from './feature/center-business/stock/delivery/delivery-order/stock-delivery-order.component';
import { StockDeliveryResultComponent } from './feature/center-business/stock/delivery/result/stock-delivery-result.component';
import { DeliveryViewComponent } from './feature/center-business/stock/delivery/delivery-order/view/delivery-order-view.component';
import { OutboundDeliveryOrderAddComponent } from './feature/center-business/stock/delivery/delivery-order/add/outbound-delivery-order-add.component';
import { DeliveryResultViewComponent } from './feature/center-business/stock/delivery/result/view/delivery-result-view.component';
import { ReservedInventoryComponent } from './feature/center-business/stock/reserved-inventory/reserved-inventory.component';
import { ReservedInventoryDetailComponent } from './feature/center-business/stock/reserved-inventory/components/detail/detail.component';
import { BatchComponent } from './feature/center-business/stock/batch/batch.component';
import { LotTraceComponent } from './feature/center-business/stock/lot-trace/lot-trace.component';
import { FefoViolationComponent } from './feature/center-business/stock/fefo-violation/fefo-violation.component';
import { FefoComplianceComponent } from './feature/center-business/stock/fefo-compliance/fefo-compliance.component';
import { BatchAddComponent } from './feature/center-business/stock/batch/batch-add/batch-add.component';
import { BatchDetailComponent } from './feature/center-business/stock/batch/batch-detail/batch-detail.component';
import { CouponComponent } from './feature/center-business/marketing/coupon/coupon.component';
import { CouponAddComponent } from './feature/center-business/marketing/coupon/add/coupon-add.component';
import { FlashSaleComponent } from './feature/center-business/marketing/flash-sale/flash-sale.component';
import { ClassifyComponent } from './feature/center-business/goods/classify/classify.component';
import { ClassifyListComponent } from './feature/center-business/goods/classify/components/classify-list/classify-list.component';
import { ClassifyAddComponent } from './feature/center-business/goods/classify/components/classify-add/classify-add.component';
import { ClassifyEditComponent } from './feature/center-business/goods/classify/components/classify-edit/classify-edit.component';
import { ClassifyViewComponent } from './feature/center-business/goods/classify/components/classify-view/classify-view.component';
import { UserSettingsComponent } from './ui/user-settings/user-settings.component';
import { UserProfileComponent } from './ui/user-profile/user-profile.component';
import { UploadDetailConfigComponent } from './feature/configuration/upload-detail-config/upload-detail-config.component';
import { PaymentConfigComponent } from './feature/configuration/finance/payment-config/payment-config.component';
import { SerialProfileComponent } from './feature/configuration/product/serial-profile/serial-profile.component';
import { SkuBarcodeComponent } from './feature/configuration/product/sku-barcode/sku-barcode.component';
import { LotBarcodeComponent } from './feature/configuration/product/lot-barcode/lot-barcode.component';
import { TaxCategoryComponent } from './feature/configuration/product/tax-category/tax-category.component';
import { AlertSettingsComponent } from './feature/configuration/inventory/alert-settings/alert-settings.component';
import { StockHoldTimeoutComponent } from './feature/configuration/inventory/stock-hold-timeout/stock-hold-timeout.component';
import { ReturnExpiryThresholdComponent } from './feature/configuration/inventory/return-expiry-threshold/return-expiry-threshold.component';
import { ReturnExceptionComponent } from './feature/center-business/after/return-exception/return-exception.component';
import { ModificationApprovalTimeoutComponent } from './feature/configuration/order/modification-approval-timeout/modification-approval-timeout.component';
import { ModificationApprovalThresholdComponent } from './feature/configuration/order/modification-approval-threshold/modification-approval-threshold.component';
import { PurchaseOrderConfigComponent } from './feature/configuration/order/purchase-order-config/purchase-order-config.component';
import { DeliveryRetryConfigComponent } from './feature/configuration/order/delivery-retry-config/delivery-retry-config.component';
import { CashPaymentMaxAmountComponent } from './feature/configuration/order/cash-payment-max-amount/cash-payment-max-amount.component';
import { EmployeeMgmtComponent } from './feature/configuration/user/employee-mgmt/employee-mgmt.component';
import { BusinessUnitComponent } from './feature/configuration/user/business-unit/business-unit.component';
import { RolesComponent } from './feature/configuration/user/roles/roles.component';
import { RolesListComponent } from './feature/configuration/user/roles/components/roles-list/roles-list.component';
import { JobRoleMappingComponent } from './feature/configuration/user/job-role-mapping/job-role-mapping.component';
import { AiAgentKeysComponent } from './feature/configuration/user/ai-agent-keys/ai-agent-keys.component';
import { CompanyComponent } from './feature/configuration/user/organizational/company/company.component';
import { CarrierComponent } from './feature/configuration/logistics/carrier/carrier.component';
import { CarrierFormComponent } from './feature/configuration/logistics/carrier/carrier-form/carrier-form.component';
import { SynchronizationComponent } from './feature/center-business/stock/synchronization/synchronization.component';
import { SynchronizationAddComponent } from './feature/center-business/stock/synchronization/components/synchronization-add/synchronization-add.component';
import { SynchronizationEditComponent } from './feature/center-business/stock/synchronization/components/synchronization-edit/synchronization-edit.component';
import { WarehouseListComponent } from './feature/center-business/channel/warehouse/warehouse-list/warehouse-list.component';
import { WarehouseFormComponent } from './feature/center-business/channel/warehouse/warehouse-form/warehouse-form.component';
import { LogicalWarehouseListComponent } from './feature/center-business/channel/warehouse/logical-warehouse/logical-warehouse-list/logical-warehouse-list.component';
import { LogicalWarehouseFormComponent } from './feature/center-business/channel/warehouse/logical-warehouse/logical-warehouse-form/logical-warehouse-form.component';
import { VirtualWarehouseListComponent } from './feature/center-business/channel/warehouse/virtual-warehouse/virtual-warehouse-list/virtual-warehouse-list.component';
import { VirtualWarehouseFormComponent } from './feature/center-business/channel/warehouse/virtual-warehouse/virtual-warehouse-form/virtual-warehouse-form.component';
import { VirtualWarehousePageListComponent } from './feature/center-business/channel/warehouse/virtual-warehouse/virtual-warehouse-page-list/virtual-warehouse-page-list.component';
import { VirtualWarehouseCreateComponent } from './feature/center-business/channel/warehouse/virtual-warehouse/virtual-warehouse-create/virtual-warehouse-create.component';
import { BpmnListComponent } from './feature/workflow/bpmn/bpmn-list/bpmn-list.component';
import { BpmnCreateComponent } from './feature/workflow/bpmn/bpmn-create/bpmn-create.component';
import { BpmnViewComponent } from './feature/workflow/bpmn/bpmn-view/bpmn-view.component';
import { BpmnEditComponent } from './feature/workflow/bpmn/bpmn-edit/bpmn-edit.component';
import { HomepageComponent } from './ui/homepage/homepage.component';

// Purchase Order Management imports
import { PurchaseOrderComponent } from './feature/center-business/procurement/purchase-order/purchase-order.component';
import { PurchaseOrderAddComponent } from './feature/center-business/procurement/purchase-order/purchase-order-add/purchase-order-add.component';
import { PurchaseOrderEditComponent } from './feature/center-business/procurement/purchase-order/purchase-order-edit/purchase-order-edit.component';
import { PurchaseOrderViewComponent } from './feature/center-business/procurement/purchase-order/purchase-order-view/purchase-order-view.component';
import { ConfirmVendorComponent } from './feature/center-business/procurement/purchase-order/confirm-vendor/confirm-vendor.component';
import { PurchaseReturnOrderComponent } from './feature/center-business/procurement/purchase-return-order/purchase-return-order.component';
import { PurchaseReturnOrderAddComponent } from './feature/center-business/procurement/purchase-return-order/purchase-return-order-add/purchase-return-order-add.component';
import { PurchaseReturnOrderViewComponent } from './feature/center-business/procurement/purchase-return-order/purchase-return-order-view/purchase-return-order-view.component';
import { PurchaseReturnOrderEditComponent } from './feature/center-business/procurement/purchase-return-order/purchase-return-order-edit/purchase-return-order-edit.component';

// Vendor Management imports
import { VendorComponent } from './feature/center-business/procurement/vendor/vendor.component';
import { VendorAddComponent } from './feature/center-business/procurement/vendor/vendor-add/vendor-add.component';
import { VendorEditComponent } from './feature/center-business/procurement/vendor/vendor-edit/vendor-edit.component';
import { VendorViewComponent } from './feature/center-business/procurement/vendor/vendor-view/vendor-view.component';
import { VendorManageSkuComponent } from './feature/center-business/procurement/vendor/vendor-manage-sku/vendor-manage-sku.component';

// Promotion Management imports
import { PROMOTION_MANAGEMENT_ROUTES } from './feature/promotion-management/promotion-management.routes';

// Retail Store Management imports
import { RetailStoreComponent } from './feature/center-business/channel/retail-store/retail-store.component';
import { RetailStoreAddComponent } from './feature/center-business/channel/retail-store/retail-store-add/retail-store-add.component';
import { RetailStoreEditComponent } from './feature/center-business/channel/retail-store/retail-store-edit/retail-store-edit.component';

// Goods Shop Management imports
import { GoodsShopComponent } from './feature/center-business/channel/goods-shop/goods-shop.component';
import { GoodsShopListComponent } from './feature/center-business/channel/goods-shop/good-shop-list/goods-shop-list.component';
import { RetailStoreViewComponent } from './feature/center-business/channel/retail-store/retail-store-view/retail-store-view.component';
import { SynchronizationViewComponent } from './feature/center-business/stock/synchronization/components/synchronization-view/synchronization-view.component';
import { OnlineStoreComponent } from './feature/center-business/channel/online-store/online-store.component';
import { OnlineStoreViewComponent } from './feature/center-business/channel/online-store/online-store-view/online-store-view.component';
import { OnlineStoreEditComponent } from './feature/center-business/channel/online-store/online-store-edit/online-store-edit.component';
import { OnlineStoreAddComponent } from './feature/center-business/channel/online-store/online-store-add/online-store-add.component';
import { ProductListingFormComponent } from './feature/center-business/channel/online-store/components/product-listing-form/product-listing-form.component';

// POS Profile Management routes
import { PosProfileComponent } from './feature/center-business/pos/pos-profile/pos-profile.component';
import { PosProfileAddComponent } from './feature/center-business/pos/pos-profile/pos-profile-add/pos-profile-add.component';
import { PosProfileEditComponent } from './feature/center-business/pos/pos-profile/pos-profile-edit/pos-profile-edit.component';
import { PosProfileViewComponent } from './feature/center-business/pos/pos-profile/pos-profile-view/pos-profile-view.component';
import { PosShiftOpenComponent } from './feature/center-business/pos/pos-shift-open/pos-shift-open.component';
import { PosShiftOpenViewComponent } from './feature/center-business/pos/pos-shift-open/pos-shift-open-view/pos-shift-open-view.component';
import { PosShiftCloseComponent } from './feature/center-business/pos/pos-shift-close/pos-shift-close.component';
import { PosShiftCloseViewComponent } from './feature/center-business/pos/pos-shift-close/pos-shift-close-view/pos-shift-close-view.component';

// Purchase Request Management imports
import { PurchaseRequestComponent } from './feature/center-business/procurement/purchase-request/purchase-request.component';
import { PurchaseRequestAddComponent } from './feature/center-business/procurement/purchase-request/purchase-request-add/purchase-request-add.component';
import { PurchaseRequestViewComponent } from './feature/center-business/procurement/purchase-request/purchase-request-view/purchase-request-view.component';
import { PurchaseRequestEditComponent } from './feature/center-business/procurement/purchase-request/purchase-request-edit/purchase-request-edit.component';
import { SalesRequestComponent } from './feature/center-business/distribution/sales-request/sales-request.component';
import { SalesRequestAddComponent } from './feature/center-business/distribution/sales-request/sales-request-add/sales-request-add.component';
import { SalesRequestViewComponent } from './feature/center-business/distribution/sales-request/sales-request-view/sales-request-view.component';
import { SalesOrderComponent } from './feature/center-business/distribution/sales-order/sales-order.component';
import { SalesOrderAddComponent } from './feature/center-business/distribution/sales-order/sales-order-add/sales-order-add.component';
import { SalesOrderViewComponent } from './feature/center-business/distribution/sales-order/sales-order-view/sales-order-view.component';

// Payment History Management imports
import { PaymentHistoryComponent } from './feature/center-business/finance/payment-history/payment-history.component';
import { ViewHistoryComponent } from './feature/center-business/finance/payment-history/components/view-history/view-history.component';
import { StockAlertComponent } from './feature/center-business/stock/stock-alert/stock-alert.component';

// E-Invoice Management imports
import { EInvoiceProviderComponent } from './feature/configuration/e-invoice/provider/e-invoice-provider.component';
import { ProviderFormComponent } from './feature/configuration/e-invoice/provider/provider-form/provider-form.component';
import { EInvoiceAccountComponent } from './feature/configuration/e-invoice/account/e-invoice-account.component';
import { AccountFormComponent } from './feature/configuration/e-invoice/account/account-form/account-form.component';
import { EInvoiceHistoryComponent } from './feature/configuration/e-invoice/history/e-invoice-history.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'test-receive',
    component: ReceiveGoodsComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'test-receive/:id',
    component: ReceiveGoodsComponent,
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomepageComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'order/internal',
    component: PageIndexComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/order/internal',
    },
  },
  {
    path: 'order/internal/add',
    component: OrderCreateComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/order/internal', // Use parent route for create action
    },
  },
  {
    path: 'order/internal/view/:orderId',
    component: StandardOrderViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/order/internal',
    },
  },
  {
    path: 'configuration/master-data/tag-management',
    component: TagManagement,
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/master-data/tag-management',
    },
  },
  {
    path: 'order/audit',
    component: OrderAuditComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/order/audit',
    },
  },
  {
    path: 'order/preempt',
    component: OrderPreemptComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/order/preempt',
    },
  },
  {
    path: 'order/source',
    component: OrderSourceComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/order/source',
    },
  },
  {
    path: 'order/short',
    component: OrderShortComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/order/short',
    },
  },
  {
    path: 'o2o/internal',
    component: O2OInternalComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/o2o/internal',
    },
  },
  {
    path: 'o2o/internal/add',
    component: O2OCreateComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/o2o/internal', // Use parent route for create action
    },
  },
  {
    path: 'o2o/audit',
    component: O2OAuditComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/o2o/audit',
    },
  },
  {
    path: 'o2o/change-history',
    component: O2OChangeHistoryComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/o2o/change-history',
    },
  },
  {
    path: 'o2o/stuck-alerts',
    component: O2oStuckAlertComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/o2o/stuck-alerts',
    },
  },
  {
    path: 'o2o/view/:orderId',
    component: O2OOrderViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/o2o/internal', // Use parent route for view action
    },
  },
  {
    path: 'third/o2o',
    component: ThirdPartyO2OComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'third/after',
    component: ThirdPartyAfterComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'third/order',
    component: MarketplaceOrderComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/third/order',
    },
  },
  {
    path: 'third/order/view/:id',
    component: MarketplaceOrderViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/third/order', // Use parent route for view action
    },
  },
  {
    path: 'third/goods',
    component: ThirdPartyGoodsComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'goods/spu/ordinary/add',
    component: OrdinarySpuAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for create action
    },
  },
  {
    path: 'goods/spu/ordinary/edit',
    component: OrdinarySpuEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for edit action
    },
  },
  {
    path: 'goods/spu/ordinary/view',
    component: OrdinarySpuViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action
    },
  },
  {
    path: 'goods/spu/package/add',
    component: PackageSpuAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for create action
    },
  },
  {
    path: 'goods/spu/package/edit',
    component: PackageSpuEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for edit action
    },
  },
  {
    path: 'goods/spu/package/view',
    component: PackageSpuViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action
    },
  },
  {
    path: 'goods/brand',
    component: BrandComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action
    },
  },
  {
    path: 'goods/brand/add',
    component: BrandAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for create action
    },
  },
  {
    path: 'goods/brand/edit',
    component: BrandEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for edit action
    },
  },
  {
    path: 'stock/search',
    component: StockSearchComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/search',
    },
  },
  {
    path: 'stock/barcode-corrections',
    component: BarcodeCorrectionsComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/barcode-corrections',
    },
  },
  {
    path: 'goods/product-pricing',
    component: PriceListComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'configuration/price/selling-tabs',
    component: SellingPricePolicyComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/configuration/price/selling-tabs',
    },
  },
  {
    path: 'configuration/price/flash-sale-quota',
    component: FlashSaleQuotaPolicyComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/configuration/price/flash-sale-quota',
    },
  },
  {
    path: 'goods/price-history',
    component: PriceHistoryComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/price-history',
    },
  },
  {
    path: 'goods/product-pricing/edit/:id',
    component: ProductPricingEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'goods/product-pricing/add',
    component: ProductPricingAddComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/change',
    component: StockChangeComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/package-operation',
    component: PackageOperationComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/package-operation',
    },
  },
  {
    path: 'stock/change-approval',
    component: ChangeApprovalComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/inbound',
    component: InboundComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound',
    },
  },
  {
    path: 'stock/inbound/add',
    component: InboundAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for create action
    },
  },
  {
    path: 'stock/inbound/warrant-view/:id',
    component: InboundWarrantViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/inbound/inbound-notice/view/:id',
    component: InboundNoticeViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/inbound/inbound-notice/edit/:id',
    component: InboundNoticeEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for update action
    },
  },
  {
    path: 'stock/inbound/edit/:id',
    component: InboundEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for update action
    },
  },
  {
    path: 'stock/inbound/receive/:id',
    component: ReceiveGoodsComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/inbound/result-view/:id',
    component: InboundResultViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/view/:type/:id',
    component: StockViewComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/transfer-order',
    component: LogicTransferComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/transfer-order/add',
    component: LogicTransferAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for create action
    },
  },
  {
    path: 'stock/transfer-order/edit/:id',
    component: LogicTransferEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for update action
    },
  },
  {
    path: 'stock/transfer-order/view',
    component: LogicTransferViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/transfer/virtual/add',
    component: TransferAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/transfer/virtual/view',
    component: TransferViewComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/reserved-inventory',
    component: ReservedInventoryComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/reserved-inventory/:id',
    component: ReservedInventoryDetailComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'stock/lot-trace',
    component: LotTraceComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/fefo-violation',
    component: FefoViolationComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/fefo-compliance',
    component: FefoComplianceComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/batch',
    component: BatchComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/batch/add',
    component: BatchAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for create action
    },
  },
  {
    path: 'stock/batch/:id',
    component: BatchDetailComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/alert',
    component: StockAlertComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/synchronization',
    component: SynchronizationComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/synchronization/add',
    component: SynchronizationAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for create action
    },
  },
  {
    path: 'stock/synchronization/edit',
    component: SynchronizationEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for update action
    },
  },
  {
    path: 'stock/synchronization/view',
    component: SynchronizationViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'report/sale-report',
    component: SaleReportComponent,
    canActivate: [unifiedAuthGuard],
  },

  // Marketing Management routes
  {
    path: 'marketing/flash-sale',
    component: FlashSaleComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/marketing/flash-sale',
    },
  },
  {
    path: 'marketing/flash-sale/:id',
    component: FlashSaleComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/marketing/flash-sale',
    },
  },
  {
    path: 'marketing/coupon',
    component: CouponComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/marketing/coupon',
    },
  },
  {
    path: 'marketing/coupon/add',
    component: CouponAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/marketing/coupon', // Use parent route for create action
    },
  },
  {
    path: 'marketing/coupon/edit/:id',
    component: CouponAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/marketing/coupon', // Use parent route for update action
    },
  },
  {
    path: 'marketing/coupon/view/:id',
    component: CouponAddComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/marketing/coupon',
    },
  },

  // Promotion Management routes
  {
    path: 'marketing/promotion',
    children: PROMOTION_MANAGEMENT_ROUTES,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/marketing/promotion',
    },
  },
  // SPU Management with tabs (parent + children)
  {
    path: 'goods/spu',
    component: SpuManagerComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'ordinary' },
      {
        path: 'ordinary',
        component: OrdinarySpuComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/goods/spu',
        },
      },
      {
        path: 'package',
        component: PackageSpuComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/goods/spu',
        },
      },
    ],
  },

  {
    path: 'after/return-exception',
    component: ReturnExceptionComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/after/return-exception' },
  },

  // Internal After parent with children
  {
    path: 'after/internal',
    component: InternalAfterComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/after/internal/return',
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'return' },
      {
        path: 'return',
        component: InternalReturnComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/after/internal/return',
        },
      },
      {
        path: 'return/view/:id',
        component: InternalReturnViewComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/after/internal/return',
        },
      },
    ],
  },

  // After Audit with tabs (parent + children)
  {
    path: 'after/audit',
    component: AfterAuditComponent,
    canActivate: [unifiedAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'return' },
      {
        path: 'return',
        component: ReturnAuditComponent,
        canActivate: [unifiedAuthGuard],
      },
    ],
  },

  // Product Review routes
  {
    path: 'goods/audit/sku/:type',
    component: ProductReviewComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'goods/audit/sku',
    redirectTo: '/goods/audit/sku/ordinary',
    pathMatch: 'full',
  },

  // SKU Management routes
  {
    path: 'goods/sku/:type',
    component: SKUManagementComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action
    },
  },
  {
    path: 'goods/sku/:type/view/:id',
    component: SKUDetailComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action
    },
  },
  {
    path: 'goods/sku/:type/edit/:id',
    component: SKUEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for edit action
    },
  },
  {
    path: 'goods/sku/ordinary/add',
    component: SKUCreateComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for create action
    },
  },
  {
    path: 'goods/sku/package/add',
    component: SKUCreateComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for create action
    },
  },
  {
    path: 'goods/sku',
    redirectTo: '/goods/sku/ordinary',
    pathMatch: 'full',
  },

  // Product Detail routes
  {
    path: 'goods/audit/:type/view/:product_id',
    component: ProductDetailComponent,
    canActivate: [unifiedAuthGuard],
  },

  // Product Audit routes
  {
    path: 'goods/audit/:type/audit/:product_id',
    component: ProductAuditComponent,
    canActivate: [unifiedAuthGuard],
  },

  // Material Management routes
  {
    path: 'goods/material',
    component: MaterialComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action
    },
    children: [
      {
        path: '',
        component: MaterialListComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/goods/spu',
        },
      },
      {
        path: 'add',
        component: MaterialFormComponent,
    canDeactivate: [CanDeactivateGuard],
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/goods/spu', // Use parent route for create action
        },
      },
      {
        path: 'edit',
        component: MaterialFormComponent,
    canDeactivate: [CanDeactivateGuard],
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/goods/spu', // Use parent route for update action
        },
      },
      {
        path: 'view',
        component: MaterialFormComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/goods/spu',
        },
      },
    ],
  },

  // Sync Error Report (RBA-2266)
  {
    path: 'goods/sync-report',
    component: SyncReportComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/spu', // Use parent route for view action, same as other Product-area reads
    },
  },

  // Classify Management routes
  {
    path: 'goods/classify',
    component: ClassifyComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/goods/classify',
    },
    children: [
      {
        path: '',
        component: ClassifyListComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          permissions: ['product.category.view'],
        },
      },
      {
        path: 'drafts',
        loadComponent: () =>
          import('./feature/center-business/goods/classify/components/category-draft-list/category-draft-list.component')
            .then((m) => m.CategoryDraftListComponent),
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: { permissions: ['product.category.view'] },
      },
      {
        path: 'drafts/:id',
        loadComponent: () =>
          import('./feature/center-business/goods/classify/components/category-draft-detail/category-draft-detail.component')
            .then((m) => m.CategoryDraftDetailComponent),
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: { permissions: ['product.category.view'] },
      },
      {
        path: 'add',
        component: ClassifyAddComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          permissions: ['product.category.create'],
        },
      },
      {
        path: 'edit/:id',
        component: ClassifyEditComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          permissions: ['product.category.edit'],
        },
      },
      {
        path: 'view/:id',
        component: ClassifyViewComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          permissions: ['product.category.view'],
        },
      },
    ],
  },

  // Stock Delivery with tabs (parent + children)
  {
    path: 'stock/delivery',
    component: StockDeliveryManagerComponent,
    canActivate: [unifiedAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'delivery-order' },
      {
        path: 'delivery-order',
        component: StockDeliveryOrderComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/stock/delivery',
        },
      },
      {
        path: 'result',
        component: StockDeliveryResultComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/stock/delivery',
        },
      },
    ],
  },
  {
    path: 'stock/delivery/delivery-order/add',
    component: OutboundDeliveryOrderAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/inbound', // Use parent route for create action
    },
  },
  {
    path: 'stock/delivery/delivery-order/view/:id',
    component: DeliveryViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/delivery/result/view/:id',
    component: DeliveryResultViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {},
  },
  {
    path: 'stock/delivery/pick/:id',
    component: PickGoodsComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/delivery',
    },
  },
  {
    path: 'stock/delivery/confirm-shipping/:id',
    component: ConfirmShippingComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/stock/delivery',
    },
  },

  // User Settings route
  {
    path: 'user/settings',
    component: UserSettingsComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'user/profile',
    component: UserProfileComponent,
    canActivate: [unifiedAuthGuard],
  },

  // Channel Management routes
  {
    path: 'warehouse/channel',
    component: WarehouseListComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/warehouse/channel' },
  },
  {
    path: 'warehouse/channel/add',
    component: WarehouseFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/warehouse/channel' },
  },
  {
    path: 'warehouse/channel/edit/:id',
    component: WarehouseFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/warehouse/channel' },
  },
  // Logical Warehouse Management routes
  {
    path: 'warehouse/logical',
    component: LogicalWarehouseListComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/warehouse/logical',
    },
  },
  {
    path: 'warehouse/logical/add',
    component: LogicalWarehouseFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/warehouse/logical', // Use parent route for create action
    },
  },
  {
    path: 'warehouse/logical/edit/:id',
    component: LogicalWarehouseFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/warehouse/logical', // Use parent route for update action
    },
  },
  {
    path: 'warehouse/virtual',
    component: VirtualWarehouseListComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/warehouse/logical',
    },
  },
  {
    path: 'warehouse/virtual/add',
    component: VirtualWarehouseFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/warehouse/logical', // Use parent route for create action
    },
  },
  {
    path: 'warehouse/virtual/edit/:id',
    component: VirtualWarehouseFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/warehouse/logical', // Use parent route for update action
    },
  },
  {
    path: 'warehouse/virtual-page',
    component: VirtualWarehousePageListComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/warehouse/virtual-page' },
  },
  {
    path: 'warehouse/virtual-page/add',
    component: VirtualWarehouseCreateComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/warehouse/virtual-page' },
  },
  {
    path: 'warehouse/virtual-page/edit/:id',
    component: VirtualWarehouseCreateComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/warehouse/virtual-page' },
  },
  // Configuration routes (Admin only)
  {
    path: 'configuration/upload-detail-config',
    component: UploadDetailConfigComponent,
    canActivate: [adminAuthGuard],
  },
  {
    path: 'configuration/product/serial-profile',
    component: SerialProfileComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/goods/classify' },
  },
  {
    path: 'configuration/product/sku-barcode',
    component: SkuBarcodeComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/product/sku-barcode' },
  },
  {
    path: 'configuration/product/lot-barcode',
    component: LotBarcodeComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/product/lot-barcode' },
  },
  {
    path: 'configuration/product/tax-categories',
    component: TaxCategoryComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/product/tax-categories' },
  },
  {
    path: 'configuration/inventory/alert-settings',
    component: AlertSettingsComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/stock/delivery' },
  },
  {
    path: 'configuration/inventory/stock-hold-timeout',
    component: StockHoldTimeoutComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/stock/delivery' },
  },
  {
    path: 'configuration/inventory/return-expiry-threshold',
    component: ReturnExpiryThresholdComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/inventory/return-expiry-threshold' },
  },
  {
    path: 'configuration/finance/payment-configuration',
    component: PaymentConfigComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'configuration/finance/payment-configuration/add',
    component: PaymentConfigComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'configuration/finance/payment-configuration/edit/:id',
    component: PaymentConfigComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'configuration/finance/payment-configuration/view/:id',
    component: PaymentConfigComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'configuration/procurement/purchase-order-config',
    component: PurchaseOrderConfigComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/procurement/purchase-order' },
  },
  {
    path: 'configuration/order/modification-approval-timeout',
    component: ModificationApprovalTimeoutComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/order/modification-approval-timeout' },
  },
  {
    path: 'configuration/order/modification-approval-threshold',
    component: ModificationApprovalThresholdComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/order/modification-approval-threshold' },
  },
  {
    path: 'configuration/order/delivery-retry',
    component: DeliveryRetryConfigComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/order/delivery-retry' },
  },
  {
    path: 'configuration/order/cash-payment-max-amount',
    component: CashPaymentMaxAmountComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/order/cash-payment-max-amount' },
  },

  // Employee Management routes (Now uses User Roles Assignment component)
  {
    path: 'configuration/user/employee',
    component: EmployeeMgmtComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/configuration/user/employee' },
  },

  // Business Unit Management routes
  {
    path: 'configuration/user/business-unit',
    component: BusinessUnitComponent,
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/user/business-unit',
    },
  },

  // User Roles Assignment
  // Removed separate user-management route

  // Company Management routes
  {
    path: 'channel/company',
    component: CompanyComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: { route: '/channel/company' },
  },

  // Roles and Permissions routes
  {
    path: 'configuration/user/roles',
    component: RolesComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/configuration/user/roles',
    },
    children: [
      {
        path: '',
        component: RolesListComponent,
        canActivate: [unifiedAuthGuard, permissionGuard],
        data: {
          route: '/configuration/user/roles',
        },
      },
    ],
  },

  // Job Position -> Keycloak Role mapping
  {
    path: 'configuration/user/job-role-mapping',
    component: JobRoleMappingComponent,
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/user/job-role-mapping',
    },
  },

  {
    path: 'configuration/user/ai-agent-keys',
    component: AiAgentKeysComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/configuration/user/ai-agent-keys',
    },
  },

  // Carrier Management routes
  {
    path: 'configuration/carrier',
    component: CarrierComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },
  {
    path: 'configuration/carrier/view/:id',
    component: CarrierFormComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },
  {
    path: 'configuration/carrier/add',
    component: CarrierFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },
  {
    path: 'configuration/carrier/edit/:id',
    component: CarrierFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },

  // Retail Store Management routes
  {
    path: 'channel/retail-store',
    component: RetailStoreComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/retail-store',
    },
  },
  {
    path: 'channel/retail-store/add',
    component: RetailStoreAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/retail-store', // Use parent route for create action
    },
  },
  {
    path: 'channel/retail-store/edit/:id',
    component: RetailStoreEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/retail-store', // Use parent route for edit action
    },
  },
  {
    path: 'channel/retail-store/view/:id',
    component: RetailStoreViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/retail-store', // Use parent route for view action
    },
  },

  // Online Store Management routes
  {
    path: 'channel/online-store',
    component: OnlineStoreComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store',
    },
  },
  {
    path: 'channel/online-store/lazada',
    component: OnlineStoreComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store',
    },
  },
  {
    path: 'channel/online-store/shopee',
    component: OnlineStoreComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store',
    },
  },
  {
    path: 'channel/online-store/add',
    component: OnlineStoreAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store', // Use parent route for create action
    },
  },
  {
    path: 'channel/online-store/edit/:id',
    component: OnlineStoreEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store', // Use parent route for edit action
    },
  },
  {
    path: 'channel/online-store/view/:id',
    component: OnlineStoreViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store', // Use parent route for view action
    },
  },
  {
    path: 'channel/online-store/:id/product-listing/add',
    component: ProductListingFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store', // Use parent route for create action
    },
  },
  {
    path: 'channel/online-store/:id/product-listing/view/:productId',
    component: ProductListingFormComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store', // Use parent route for view action
    },
  },
  {
    path: 'channel/online-store/:id/product-listing/edit/:productId',
    component: ProductListingFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/channel/online-store', // Use parent route for edit action
    },
  },

  // POS Profile Management routes
  {
    path: 'pos/profile',
    component: PosProfileComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/profile',
    },
  },
  {
    path: 'pos/profile/add',
    component: PosProfileAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/profile', // Use parent route for create action
    },
  },
  {
    path: 'pos/profile/edit/:id',
    component: PosProfileEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/profile', // Use parent route for update action
    },
  },
  {
    path: 'pos/profile/view/:id',
    component: PosProfileViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/profile',
    },
  },

  // POS Shift Opening Tracking Management routes
  {
    path: 'pos/shift-open',
    component: PosShiftOpenComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/shift-open',
    },
  },
  {
    path: 'pos/shift-open/view/:id',
    component: PosShiftOpenViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/profile',
    },
  },

  // POS Shift Closing Tracking Management routes
  {
    path: 'pos/shift-close',
    component: PosShiftCloseComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/shift-close',
    },
  },
  {
    path: 'pos/shift-close/view/:id',
    component: PosShiftCloseViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/pos/profile',
    },
  },

  // Goods Shop Management routes
  {
    path: 'channel/goods-shop',
    component: GoodsShopListComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'channel/goods-shop/:shopId/:shopName',
    component: GoodsShopComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'channel/goods-shop/:shopId/:shopName/edit/:id',
    component: GoodsShopComponent,
    canActivate: [unifiedAuthGuard],
  },
  // BPMN Workflow routes (SUPER ADMIN only)
  {
    path: 'configuration/master-data/workflow-engine',
    loadComponent: () =>
      import('./feature/workflow/engine-settings/workflow-engine-settings.component').then(
        (m) => m.WorkflowEngineSettingsComponent,
      ),
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'configuration/master-data/bpmn',
    component: BpmnListComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },
  {
    path: 'configuration/master-data/bpmn/add',
    component: BpmnCreateComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },
  {
    path: 'configuration/master-data/bpmn/view/:id',
    component: BpmnViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },
  {
    path: 'configuration/master-data/bpmn/edit/:id',
    component: BpmnEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      /* Super admin routes - no route mapping needed */
    },
  },

  // Purchase Request Management routes
  {
    path: 'procurement/purchase-request',
    component: PurchaseRequestComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request',
    },
  },
  {
    path: 'procurement/purchase-request/add',
    component: PurchaseRequestAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request', // Use parent route for create action
    },
  },
  {
    path: 'procurement/purchase-request/view/:id',
    component: PurchaseRequestViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request',
    },
  },
  {
    path: 'procurement/purchase-request/edit/:id',
    component: PurchaseRequestEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request', // Use parent route for update action
    },
  },

  // Purchase Order Management routes
  {
    path: 'procurement/purchase-order',
    component: PurchaseOrderComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-order',
    },
  },
  {
    path: 'procurement/purchase-order/add',
    component: PurchaseOrderAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-order', // Use parent route for create action
    },
  },
  {
    path: 'procurement/purchase-order/edit/:id',
    component: PurchaseOrderEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-order', // Use parent route for update action
    },
  },
  {
    path: 'procurement/purchase-order/view/:id',
    component: PurchaseOrderViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-order',
    },
  },
  {
    path: 'procurement/purchase-order/confirm-vendor/:id',
    component: ConfirmVendorComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-order',
    },
  },

  // Distribution (dealer) - Sales Request routes
  {
    path: 'distribution/sales-request',
    component: SalesRequestComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/distribution/sales-request',
    },
  },
  {
    path: 'distribution/sales-request/add',
    component: SalesRequestAddComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/distribution/sales-request', // Use parent route for create action
    },
  },
  {
    path: 'distribution/sales-request/view/:id',
    component: SalesRequestViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/distribution/sales-request',
    },
  },

  // Distribution (dealer) - Sales Order routes
  {
    path: 'distribution/sales-order',
    component: SalesOrderComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/distribution/sales-order',
    },
  },
  {
    path: 'distribution/sales-order/add',
    component: SalesOrderAddComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/distribution/sales-order', // Use parent route for create action
    },
  },
  {
    path: 'distribution/sales-order/view/:id',
    component: SalesOrderViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/distribution/sales-order',
    },
  },

  // Purchase Return Order (RTV) Management routes
  {
    path: 'procurement/purchase-return-order',
    component: PurchaseReturnOrderComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request',
    },
  },
  {
    path: 'procurement/purchase-return-order/add',
    component: PurchaseReturnOrderAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request', // Use parent route for create action
    },
  },
  {
    path: 'procurement/purchase-return-order/view/:id',
    component: PurchaseReturnOrderViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request',
    },
  },
  {
    path: 'procurement/purchase-return-order/edit/:id',
    component: PurchaseReturnOrderEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request', // Use parent route for update action
    },
  },

  // Vendor Management routes
  {
    path: 'procurement/vendor',
    component: VendorComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request',
    },
  },
  {
    path: 'procurement/vendor/add',
    component: VendorAddComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request', // Use parent route for create action
    },
  },
  {
    path: 'procurement/vendor/edit/:id',
    component: VendorEditComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request', // Use parent route for update action
    },
  },
  {
    path: 'procurement/vendor/view/:id',
    component: VendorViewComponent,
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request',
    },
  },
  {
    path: 'procurement/vendor/:id/manage-sku',
    component: VendorManageSkuComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      route: '/procurement/purchase-request',
    },
  },
  // Payment History Management routes
  {
    path: 'finance/payment-history',
    component: PaymentHistoryComponent,
    canActivate: [unifiedAuthGuard],
  },
  {
    path: 'finance/payment-history/view/:id',
    component: ViewHistoryComponent,
    canActivate: [unifiedAuthGuard],
  },

  // E-Invoice Management routes
  {
    path: 'e-invoice/history',
    component: EInvoiceHistoryComponent,
    canActivate: [unifiedAuthGuard],
    data: { route: '/e-invoice/history' },
  },
  {
    path: 'configuration/e-invoice/provider',
    component: EInvoiceProviderComponent,
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/provider',
    },
  },
  {
    path: 'configuration/e-invoice/provider/add',
    component: ProviderFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/provider',
    },
  },
  {
    path: 'configuration/e-invoice/provider/view/:id',
    component: ProviderFormComponent,
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/provider',
    },
  },
  {
    path: 'configuration/e-invoice/provider/edit/:id',
    component: ProviderFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/provider',
    },
  },
  {
    path: 'configuration/e-invoice/account',
    component: EInvoiceAccountComponent,
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/account',
    },
  },
  {
    path: 'configuration/e-invoice/account/add',
    component: AccountFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/account',
      mode: 'add',
    },
  },
  {
    path: 'configuration/e-invoice/account/view/:id',
    component: AccountFormComponent,
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/account',
      mode: 'view',
    },
  },
  {
    path: 'configuration/e-invoice/account/edit/:id',
    component: AccountFormComponent,
    canDeactivate: [CanDeactivateGuard],
    canActivate: [unifiedAuthGuard],
    data: {
      route: '/configuration/e-invoice/account',
      mode: 'edit',
    },
  },

  // HRM / CRM / Member / BPM commerce modules (lazy-loaded; permission + module flags)
  {
    path: 'hrm',
    canActivate: [unifiedAuthGuard, permissionGuard, moduleEnabledGuard],
    data: {
      permissions: [P_COMMERCE.HRM_READ],
      commerceModule: 'hrm',
    },
    loadChildren: () =>
      import('./feature/hrm/hrm.routes').then((m) => m.HRM_ROUTES),
  },
  {
    path: 'crm',
    canActivate: [unifiedAuthGuard, permissionGuard, moduleEnabledGuard],
    data: {
      permissions: [P_COMMERCE.CRM_READ],
      commerceModule: 'crm',
    },
    loadChildren: () =>
      import('./feature/crm/crm.routes').then((m) => m.CRM_ROUTES),
  },
  {
    path: 'member',
    canActivate: [unifiedAuthGuard, permissionGuard, moduleEnabledGuard],
    data: {
      permissions: [P_COMMERCE.MEMBER_READ],
      commerceModule: 'member',
    },
    loadChildren: () =>
      import('./feature/member/member.routes').then((m) => m.MEMBER_ROUTES),
  },
  {
    path: 'bpm',
    canActivate: [unifiedAuthGuard, permissionGuard, moduleEnabledGuard],
    data: {
      permissions: [P_COMMERCE.BPM_READ],
      commerceModule: 'bpm',
    },
    loadChildren: () =>
      import('./feature/bpm/bpm.routes').then((m) => m.BPM_ROUTES),
  },
  {
    path: 'platform',
    canActivate: [unifiedAuthGuard, permissionGuard],
    data: {
      permissions: [P_COMMERCE.PLATFORM_READ],
    },
    loadChildren: () =>
      import('./feature/platform/platform.routes').then((m) => m.PLATFORM_ROUTES),
  },
];
